import { salesOverviewReportSchema } from './chunk-CTZXUPKZ.mjs';
import * as yup from 'yup';

var itemComboSalesReportSchema = salesOverviewReportSchema.concat(
  yup.object().shape({
    // groupBy: yup.string().trim().required('groupByRequired'),
  })
);

export { itemComboSalesReportSchema };
